import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { BehaviorSubject, catchError, finalize, Observable, tap, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { BaseService } from './base.service';
import { LoadingService } from './loading.service';
import { Die } from '../models/domain/Die';
import { BaseSearchOptions } from '../models/core/table/BaseSearchOptions';
import { PagedResponse } from '../models/general/PagedResponse';
import { AuthenticationService } from './authentication.service';

@Injectable({
  providedIn: 'root'
})
export class DieService extends BaseService<Die> {
  private readonly rowCountSubject: BehaviorSubject<number>;
  public readonly rowCount$: Observable<number>;
  private http: HttpClient;

  constructor(http: HttpClient, loadingService: LoadingService,
    public authService: AuthenticationService
  ) {
    super(http, `${environment.apiUrl}/v1/die`, loadingService);
    this.http = http;
    this.rowCountSubject = new BehaviorSubject<number>(0);
    this.rowCount$ = this.rowCountSubject.asObservable();
  }

  public get1(parameters?: BaseSearchOptions): Observable<HttpResponse<PagedResponse<Die>>> {
    if (parameters) {
      this.currentParameters.updateByObject(parameters);
    }
    const params = new HttpParams()
      .set("filter", this.currentParameters.filter)
      .set("orderBy", this.currentParameters.orderBy)
      .set("pageSize", this.currentParameters.pageSize)
      .set("pageIndex", this.currentParameters.pageIndex)
      .set("orderByDirection", this.currentParameters.orderByDirection)
      .set("expand", this.currentParameters.expand);

    this.loadingService.showLoading();
    return this.httpClient.get<PagedResponse<Die>>(`${this.baseApiUrl}/${this.authService.getCurrentUser()?.clientId}/allDieB2B`, { params, observe: "response" })
      .pipe(tap(response => {
        this.loadingService.hideLoading();
        return response?.body?.values;
      }),
        catchError(error => {
          // Propagate the error properly to the ErrorInterceptor
          this.loadingService.hideLoading();
          return throwError(() => error); // Make sure to throw the error properly
        }),
        finalize(() => {
          this.loadingService.hideLoading();
        })
      );
  }

  public generatePdfByCategoryIds(categoryIds: number[]): Observable<HttpResponse<Blob>> {
    this.loadingService.showLoading();
    return this.http.post(`${this.baseApiUrl}/generatePdfByCategoryIds`, categoryIds, {
      responseType: 'blob',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/pdf' },
      observe: 'response'
    }).pipe(
      tap(() => {
        this.loadingService.hideLoading();
      }),
      catchError(error => {
        this.loadingService.hideLoading();
        return throwError(() => error);
      }),
      finalize(() => {
        this.loadingService.hideLoading();
      })
    );
  }

  public generatePdfByDieIds(dieIds: number[]): Observable<HttpResponse<Blob>> {
    this.loadingService.showLoading();
    return this.http.post(`${this.baseApiUrl}/generatePdfByDieIds`, dieIds, {
      responseType: 'blob',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/pdf' },
      observe: 'response'
    }).pipe(
      tap(() => {
        this.loadingService.hideLoading();
      }),
      catchError(error => {
        this.loadingService.hideLoading();
        return throwError(() => error);
      }),
      finalize(() => {
        this.loadingService.hideLoading();
      })
    );
  }

}